import React, { useMemo, useRef } from 'react';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { jpdBlueprintsFeedbackBannerEntryPoint } from '../entrypoint.tsx';
import { ENTRY_POINT_ID, PACKAGE_NAME } from './constants.tsx';

const useEntrypoint = () => {
	const entryPointParams = useMemo(() => {
		return {};
	}, []);
	const hasLoadedEntrypoint = useRef(false);
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		jpdBlueprintsFeedbackBannerEntryPoint,
		entryPointParams,
	);
	if (!hasLoadedEntrypoint.current) {
		entryPointActions.load();
		hasLoadedEntrypoint.current = true;
	}
	return { entryPointReferenceSubject };
};

export const AsyncJpdBlueprintsFeedbackBanner = () => {
	const { entryPointReferenceSubject } = useEntrypoint();

	return (
		<JiraEntryPointContainer
			id={ENTRY_POINT_ID}
			packageName={PACKAGE_NAME}
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={{}}
		/>
	);
};
